import React from 'react';
import { useSelector } from 'react-redux';
import roleAccess from './roleAccess';
import { createSelector } from 'reselect';
 
const withRoleBasedAccess = (WrappedComponent, requiredRoles) => {
  const WithRoleBasedAccess = (props) => {

    const UserProperties = createSelector(
        (state) => state.Login,
        (loginData) => ({
          userData: loginData.userData
        })
      );
 

    const { userData } = useSelector(UserProperties);

    if (!userData || !roleAccess(userData.role, requiredRoles)) {
      return null; // Return null or any fallback component for unauthorized access
    }

    return <WrappedComponent {...props} />;
  };

  WithRoleBasedAccess.displayName = `WithRoleBasedAccess(${getDisplayName(WrappedComponent)})`;

  return WithRoleBasedAccess;
};

// Helper function to get the display name of a component
const getDisplayName = (WrappedComponent) => {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
};

export default withRoleBasedAccess;